<template>
    <div :class="{['add-user-popup'] :true, ['hide'] : !display}">
        <div class="popup" ref="addUserPopupRef">
            <div class="title-section">
                <h2>{{ $t("dash.settings.users.header.add_user") }}</h2>
                <p>{{ $t('dash.settings.add_user.subtitle').replace('%',stateCarrousel) }}</p>
            </div>

            <div class="container-carrousel">
               
                <div :class="'carrousel state' + stateCarrousel">
                    <div class="slide slide1">
                        <div class="container-input name">
                            <label>{{ $t('dash.settings.add_user.name.label') }}</label>
                            <div class="inputs">
                                <div class="input">
                                    <i class="fa-regular fa-circle-user"></i>
                                    <input :placeholder="$t('dash.settings.account.name.last_name.placeholder')" v-model="form.lastname">

                                    <div class="containerError" v-if="error.lastname ">
                                        <Tooltip :position="top" :text="error.lastname">
                                            <i class="fa-regular fa-circle-exclamation"></i>
                                        </Tooltip>
                                    </div>
                                </div>

                                <div class="input">
                                    <input :placeholder="$t('dash.settings.account.name.first_name.placeholder')" v-model="form.firstname">
                                    <div class="containerError" v-if="error.firstname ">
                                        <Tooltip :position="top" :text="error.firstname">
                                            <i class="fa-regular fa-circle-exclamation"></i>
                                        </Tooltip>
                                    </div>
                                </div>

                               
                            </div>
                        </div>

                        <div class="container-input email">
                            <label>{{ $t("dash.settings.account.email.title") }}</label>
                            <div class="input">
                                <i class="fa-regular fa-at"></i>
                                <input placeholder="Entrez une adress Email" v-model="form.email">
                                <div class="containerError" v-if="error.email ">
                                    <Tooltip :position="top" :text="error.email">
                                        <i class="fa-regular fa-circle-exclamation"></i>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>

                        <div class="container-input pasword">
                            <label>{{ $t("dash.settings.account.password.title") }}</label>
                        
                            <div class="input">
                                <i class="fa-regular fa-key"></i>
                                <input :placeholder="$t('dash.settings.add_user.password.placeholder')" v-model="form.password">
                                <div class="containerError" v-if="error.password ">
                                    <Tooltip :position="top" :text="error.password">
                                        <i class="fa-regular fa-circle-exclamation"></i>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="slide slide2">
                        <div class="container-input role">
                            <label>{{ $t("dash.settings.users.legend.role") }}</label>
                            <div class="input">
                                <SelectComponent :changeValueSelect="changeRole" :data="getDataSelectRole()" :valueSelect="form.role" :positionY="'bottom'" :positionAuto="false"></SelectComponent>
                            </div>
                        </div>

                        <div class="container-input notifications">
                            <label>{{ $t('dash.settings.add_user.notifications.title') }}</label>
                            <div class="box">
                                <div class="notification">
                                    {{ $t('dash.settings.add_user.notifications.echec.description') }}.
                                    <ComponentSwitch :value="form.alertEchec" :onChange="handleChangeAlert" :id="'alertEchec'"></ComponentSwitch>
                                </div>
                                <div class="notification">
                                    <span v-html="$t('dash.settings.add_user.notifications.validation.description')"></span>
                                    <ComponentSwitch :value="form.alertValidation" :onChange="handleChangeAlert" :id="'alertValidation'"></ComponentSwitch>
                                </div>
                                <div class="notification">
                                    <span v-html="$t('dash.settings.add_user.notifications.inbox.description')"></span>
                                    <ComponentSwitch :value="form.alertInbox" :onChange="handleChangeAlert" :id="'alertInbox'"></ComponentSwitch>
                                </div>
                                <!-- <p class="info">{{ $t('dash.settings.add_user.notifications.description') }}</p> -->
                            </div>
                        </div>
                    </div>

                    <div class="slide slide3">
                        <div class="container-select-page">
                            <SelectPagComponenent :groups="groups" :allPages="pages_access" :SelectPageProp="SelectPage" v-on:updateSelectPage="updateSelectPage"></SelectPagComponenent>
                        </div>
                        <div class="list-page-select">
                            <p>{{ $t('dash.settings.add_user.page_select') }}</p>
                            <div class="list-avatar">
                                <Tooltip v-for="pageId in SelectPage.filter(p => findPage(p))" :position="top" :text="findPage(pageId).name" :key="pageId">
                                    <Avatar :checked="true"  :id="pageId" :urlPicture="findPage(pageId).avatar" :typeNetwork="findPage(pageId).network" v-on:click="removeSelectPage" :key="pageId"></Avatar>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="btns">
                <div class="btn-outline-primary" @click="previousStade" v-if="stateCarrousel > 1">Précédent</div>
                <div class="btn-outline-primary" @click="cancel" v-else>Annuler</div>

                <div class="btn-primary icon-r" @click="nextState" v-if="stateCarrousel < 3">Suivant</div>
                <div class="btn-primary icon-r" @click="save" v-else>Souvegarder</div>
            </div>
          
        </div>
    </div>
</template>

<script>

import ComponentSwitch from './../utils/switch.vue'
import Avatar from './../utils/avatar.vue'
import SelectPagComponenent from './../SelectPage.vue'
import SelectComponent from './../utils/select.vue'
import Tooltip from './../tooltip/tooltipInit.vue'

export default {
    name: 'addUserPopup',

    components : {
        ComponentSwitch,
        SelectPagComponenent,
        Avatar,
        SelectComponent,
        Tooltip
    },

    props:{
        
        display : Boolean,
        closePopUp : Function,
        pages_access : Array,
        groups : Array,
        submit : Function,
        roles : Array,
        data : Object,
        
        stateCarrouselDefault: {
            type : Number,
            default : 1
        },

        isAdmin : {
            type : Boolean,
            default : false
        },

        emailExist : Function,
        
    },
    data() {
        return {
            form : {
                firstname : '',
                lastname: '',
                email:'',
                password:'',
                role: 'Viewer',
                alertEchec : false,
                alertValidation : false,
                alertInbox : false
            },

            SelectPage : [],

            error : {
                firstname : '',
                lastname: '',
                email:'',
                password:'',
            },
            stateCarrousel : 1

        };   
    },
    
    mounted() {
        console.log('mounted')
        window.addEventListener('click', this.handleClickOutside);

        if (this.data && this.data.form) {
            this.form = {...this.form,...this.data.form}
        }

        if (this.data && this.data.selectPage) {
            this.SelectPage = this.data.selectPage
        }

        this.stateCarrousel = this.stateCarrouselDefault
    },



    methods: {
        changeRole(value) {
            this.form.role = value
        },

        handleChangeAlert(value,type) {
           this.form[type] = value
        },

        updateSelectPage(selectPage) {
            this.SelectPage = selectPage
        },

        getDataSelectRole() {
            const dataRole = {Viewer: this.$t("dash.settings.user.Viewer") ,Writter: this.$t("dash.settings.user.Writter"),Editor: this.$t("dash.settings.user.Editor"), Admin: this.$t("dash.settings.user.Administrator")}
            
            let newData = {};
            let indexMaxRoles = null

            if (this.isAdmin) {
                indexMaxRoles = 3
            }else if(!this.roles || this.roles.length == 0) {
                indexMaxRoles = 2
            }else{
                this.roles.forEach(role => {
                    let index = Object.keys(dataRole).indexOf(role)
                    if (index !== -1 && (indexMaxRoles == null || index > indexMaxRoles)) {
                        indexMaxRoles = index
                    }
                });
            }

            if (indexMaxRoles !== null) {
                const dataRoleEntries = Object.entries(dataRole)
                for (let i = 0; i <= indexMaxRoles; i++) {
                    newData[dataRoleEntries[i][0]] = dataRoleEntries[i][1]
                }
            }
                
            return newData
        },

        cancel(){
            this.form = {
                firstname : '',
                lastname: '',
                email:'',
                password:'',
                role: 'viewer',
                alertEchec : true,
                alertValidation : true
            },

            this.error = {
                firstname : '',
                lastname: '',
                email:'',
                password:'',
            }
            this.stateCarrousel = 1;
            this.closePopUp()
        },

        nextState(){
           
            this.error = {
                firstname : '',
                lastname: '',
                email:'',
                password:'',
            }

            let isSuccess = true;

            switch (this.stateCarrousel) {
                case 1:
                    if (this.form.lastname == "") {
                        isSuccess = false;
                        this.error.lastname = this.$t('dash.settings.add_user.error.last_name_required')
                    }

                    if (this.form.firstname == "") {
                        isSuccess = false;
                        this.error.firstname = this.$t('dash.settings.add_user.error.first_name_required')
                    }

                    if (this.form.email == "") {
                        isSuccess = false;
                        this.error.email = this.$t('dash.settings.add_user.error.email_required')

                    }else if (!this.data || !this.data.form ||  !this.data.form.email || this.data.form.email !== this.form.email) {   //nouvelle adresse ?
                        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email))) { // eslint-disable-line
                            isSuccess = false;
                            this.error.email = this.$t('dash.settings.add_user.error.email_invalid')
                        } else if(this.emailExist(this.form.email)) {
                            isSuccess = false;
                            this.error.email = this.$t('dash.settings.add_user.error.email_exist')
                        }
                    }

                    if (!this.data && this.form.password == "") {
                        isSuccess = false;
                        this.error.password = this.$t('dash.settings.add_user.error.password_required')
                    }

                    if (isSuccess) {
                        this.stateCarrousel++
                    }
                break;
            
                case 2:
                    this.stateCarrousel++
                    break;

            }



        },

        previousStade() {
            if (this.stateCarrousel > 1) {
                this.stateCarrousel--;
            }
        },

        findPage(pageId) {
            let page = this.pages_access.find(p => p.id == pageId)
            return page && page ? page : null
        },

        removeSelectPage(e,idPage) {
            e.stopPropagation()
            this.SelectPage = this.SelectPage.filter(id => id !== idPage)
        },

        async save(){
          
            const result = await this.submit({
                firstname : this.form.firstname,
                lastname: this.form.lastname,
                email: this.form.email,
                password: this.form.password,
                role: this.form.role,
                alertEchec : this.form.alertEchec,
                alertValidation : this.form.alertValidation,
                alertInbox : this.form.alertInbox,
                selectPage: this.SelectPage,
                
            })
            this.cancel()
        },

        handleClickOutside(event) {
            if (!this.$refs.addUserPopupRef.contains(event.target)) {
                window.removeEventListener("click", this.handleClickOutside, false);
                this.cancel()
            }
        },

    },

    beforeDestroy() {
        window.removeEventListener("click", this.handleClickOutside);
    },
};
</script>

